import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
  StyledSecondaryServiceTypography,
} from "../../Theme";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DeleteBorderIcon } from "../../Icons/DeleteOutline.svg";

const ReviewAccount = () => {
  const navigate = useNavigate();
  const tabs = ["Detail", "Contract"];
  const [selectedTab, setSelectedTab] = useState("Detail");
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };
  return (
    <>
      <BackArrow
        onClick={() => navigate("/company")}
        style={{ marginBottom: "20px", cursor: "pointer" }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <PrimaryTypography>The Clement Canopy</PrimaryTypography>
          <StyledSecondaryServiceTypography>
            Last Updated: 10 Jul 2023, 13:00
          </StyledSecondaryServiceTypography>
        </Box>
        <DeleteBorderIcon />
      </Box>
      <Box
        mt={3}
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 8px 8px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0px 0px",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Company Details</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            variant="outlined"
            onClick={() => navigate("/edit-company/1")}
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
            borderRadius: "0px 0px 8px 8px",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Company Name</StyledSecondaryTypography>
            <TypographyDefault>Singapore Land Group Pte Ltd</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Country</StyledSecondaryTypography>
            <TypographyDefault>Singapore</TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Email Address
            </StyledSecondaryTypography>
            <TypographyDefault>sgcontact@singaporeland.com</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contact Number
            </StyledSecondaryTypography>
            <TypographyDefault>+65 9890 4903</TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Address
            </StyledSecondaryTypography>
            <TypographyDefault>
              50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore 048623
            </TypographyDefault>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ReviewAccount;
